import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import client from "../api/client";
import * as kiosk from "../api/kiosk";
import Button from "@material-ui/core/Button";
import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Grid from "@material-ui/core/Grid";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/core/styles";
import { fetchVisits, fetchPatients } from "../actions/index";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import compose from "recompose/compose";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import SignatureCanvas from "react-signature-canvas";
import PainRelief from "../img/painReliefDiagram.jpg";
import InputMask from "react-input-mask";
import {
  AcupunctureConsent,
  OsteopathyConsent,
  MassageConsent,
  GeneralConsent,
  SensitiveAreasConsent,
  TelusConsent,
  ReikiConsent,
  NaturopathicConsent,
  PhysiotherapyConsent,
  ChiropractorConsent,
  HomeopathicConsent,
  CONSENT_TYPES,
  createConsentSnapshot,
  getConsentVersionAtDate,
  legacyFieldsToSnapshot,
} from "./consent";

let url = process.env.REACT_APP_DOMAIN;
const LEGACY_CONSENT_FALLBACK_DATE = "2017-01-01";

/**
 * Identity and contact fields the kiosk is allowed to see.
 *
 * Mirrors the server's allowlist in lib/intakeFields.js. The server is the
 * enforcement point — it simply does not send anything else — but keeping the
 * list here documents why the rest of the form starts blank on a tablet.
 *
 * Everything else is deliberately absent:
 *   PII      — dob, address, insurance, family physician: identity-theft-useful
 *              and cheap for a patient to retype.
 *   Clinical — the entire health history, including communicable-disease status.
 *              Behind a phone-number gate, prefilling that would mean guessing
 *              one phone number yields a complete clinical record.
 */
const KIOSK_PREFILL_FIELDS = [
  "firstName",
  "lastName",
  "email",
  "cellPhone",
  "homePhone",
  "emergencyContact",
  "emergencyContactTel",
];

const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#002BB8",
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
  },
});
const styles = (theme) => ({
  root: {
    width: "100%",
    // maxWidth: 500,
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  dense: {
    marginTop: 16,
  },
  menu: {
    width: 200,
  },
  exampleWrapper: {
    position: "relative",
    marginTop: theme.spacing(3),
    height: 380,
  },
  radioGroup: {
    margin: theme.spacing(1, 0),
  },
  speedDial: {
    position: "absolute",
    "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
  },
  rootDial: {
    transform: "translateZ(0px)",
    flexGrow: 1,
  },
});

class IntakeForm extends Component {
  constructor(props) {
    super(props);
    this.classes = props;
    this.state = {
      // admin view
      admin: false,
      // intake
      // input
      firstName: "",
      lastName: "",
      dob: "",
      addressStreet: "",
      addressCity: "",
      addressPostal: "",
      gender: "",
      occupation: "",
      cellPhone: "",
      homePhone: "",
      emergencyContact: "",
      emergencyContactTel: "",
      familyPhysicianName: "",
      familyPhysicianPhone: "",
      familyPhysicianAddress: "",
      referred: "",
      maritalStatus: "",
      noDependants: "",
      insurance: "",
      otherTreatment: "",
      healthConditionRequiringTreatment: "",
      onMedication: "",
      travel: "",
      allergies: "",
      surgery: "",
      injury: "",
      // checkboxes
      // cardiovascular
      pacemaker: false,
      metal: false,
      highBloodPressure: false,
      lowBloodPressure: false,
      chronicCongestiveHeartFailure: false,
      heartAttack: false,
      phlebitis: false,
      heartSurgery: false,
      heartDisease: false,
      stroke: false,
      strokeWhen: "",
      poorCirculation: false,
      familyHistoryCario: false,
      // respiratory
      chronicCough: false,
      shortnessOfBreath: false,
      bronchitis: false,
      asthma: false,
      familyHistoryResp: false,
      // digestion
      poorDigestion: false,
      IBS: false,
      constipation: false,
      liver: false,
      kidney: false,
      // head/neck
      headaches: false,
      migraines: false,
      visionProblems: false,
      visionLoss: false,
      earProblems: false,
      hearingLoss: false,
      // muscle and joint
      pain: false,
      stiffness: false,
      swelling: false,
      limitedMotion: false,
      fatigue: false,
      osteoarthritis: false,
      backPainUpper: false,
      backPainMid: false,
      backPainLower: false,
      shoulderPain: false,
      // infections
      hepA: false,
      hepB: false,
      hepC: false,
      TB: false,
      HIV: false,
      herpes: false,
      infectionsOther: "",
      // skin conditions
      sensitiveSkin: false,
      rashes: false,
      acne: false,
      coldSores: false,
      bleedingDisorder: false,
      bruiseEasily: false,
      varicoseVeins: false,
      deepVeinThrombosis: false,
      eczema: false,
      tattoos: false,
      // other conditions
      lossOfSensation: "",
      diabetes: "",
      epilepsy: false,
      cancer: "",
      multipleSclerosis: false,
      arthritis: false,
      familyHistoryArthritis: false,
      // women
      pregnant: "",
      menstruation: "",
      menopause: "",
      // general health
      generalHealthStatus: "",
      generalStressLevels: "",
      regularMeals: false,
      irregularEating: false,
      caffeine: false,
      smoke: false,
      exercise: "",
      previousMassage: false,
      previousChiro: false,
      previousPhysio: false,
      previousAcu: false,
      previousOsteo: false,
      previousPsycho: false,
      previousNaturopathic: false,
      previousHomeopathic: false,
      dateOfLastFullPhysical: "",
      otherMedicalConditions: "",
      internalPins: "",
      // other
      dentalSurgery: "",
      ofSpecialNote: "",
      painReliefDiagram: "",
      additionalInfo: "",
      email: "",
      // Massage v2 checkbox fields
      massage_postTreatmentSoreness: false,
      massage_deepTissue: false,
      massage_strenuousActivity: false,
      massage_communicateDiscomfort: false,
      massage_noSpecificOutcome: false,
      //misc
      displayError: false,
      // consent Acu
      consentAcupuncture: false,
      consentBleedEasily: false,
      consentPregnant: false,
      consentHIV: false,
      consentPacemaker: false,
      consentMetal: false,
      // consent Osteo
      consentOsteopathy: false,
      osteo_temporarySoreness: false,
      osteo_pressure: false,
      osteo_strenuousActivity: false,
      osteo_communicateDiscomfort: false,
      osteo_noSpecificOutcome: false,
      consentMassage: false,
      consentTelus: false,
      consentAcceptTerms: false,
      primaryCoverage: null,
      planMember: null,
      policyNumber: null,
      coverageCert: null,
      canadaLife: null,
      //signatures
      AcuSig: "",
      OsteoSig: "",
      MassSig: "",
      // sensitive area terms
      consentSensitive: false,
      // reiki terms
      consentReiki: false,
      reikiConsentAndWaiver: false,
      reikiTestimonialDisclaimer: false,
      reikiAssumptionOfRisk: false,
      reikiGoverningLaw: false,
      reikiExclusiveJurisdiction: false,
      // naturopath
      consentNaturopathic: false,
      // naturopathic specific fields
      currentHealthCareProviders: "",
      describeYourHealthConcerns: "",
      currentSupplements: "",
      listFamilyHistory: "",
      Diet_Restrictions: "",
      Diet_AdditionalComments: "",
      Diet_RateYourEnergy: "",
      Diet_RateYourStress: "",
      Diet_BiggestSourceOfStress: "",
      Exercise_ActivityLevel: "",
      Exercise_TypeofActivity: "",
      Exercise_OtherRelevantInfo: "",
      // physical therapy
      consentPhysiotherapy: false,
      // chiropractor
      consentChiropractor: false,
      // homeopathic
      consentHomeopathic: false,
      // general consent forms
      //  accuracy of information
      Accuracy_IAgree: false,
      //  cancellation policy
      CancellationPolicy_IAgree: false,
      //  email communication
      EmailCommunication_IAgree: false,
      //  privacy policy
      PrivacyPolicy_IAgree: false,
      //  signatory
      IWillBeSigning: false,
      substituteSignature: false,
      substituteSignatureName: "",
      consentSnapshots: {},
      consentVersions: {},
      consentSubmittedAt: null,
      isHistoricalRecord: false,
    };
    // The keys the form actually owns. Reassessment prefill only ever writes
    // these, so a stray field in a server response can never clobber a control
    // flag. The server is the enforcement point (its allowlist), this is a
    // belt-and-braces guard on top.
    this.formFieldKeys = new Set(Object.keys(this.state));
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentWillMount = () => {
    this.setState({
      sigCanvas: {
        canvasWidth: 800,
        canvasHeight: 600,
      },
    });

    // Sets the values of tags in the head
    document.title = "Intake Form | Appleby Wellness";
    let metaTags = document.getElementsByTagName("meta");
    for (let i = 0; i < metaTags.length; i++) {
      if (metaTags[i].name === "description") {
        metaTags[i].content = "";
      }
    }
  };

  safeLoadCanvasData = (canvasRef, dataUrl, options) => {
    if (canvasRef && dataUrl && typeof canvasRef.fromDataURL === "function") {
      try {
        canvasRef.fromDataURL(dataUrl, options);
      } catch (err) {
        console.log("Error loading canvas data:", err);
      }
    }
  };

  /**
   * True when the form is being filled at the waiting-room kiosk.
   *
   * The staff routes carry an `:admin` segment (`/admin/intake/:id/:admin`);
   * the public route does not. On the kiosk there is no staff session — the
   * caller holds only a visit-scoped token obtained by confirming the patient's
   * phone number.
   */
  isKioskMode() {
    return !this.props.match.params.admin;
  }

  /**
   * Paint the body diagram onto the pain-relief annotation canvas.
   *
   * Used both on mount and by `clear()` — the canvas is drawn on by the patient,
   * so clearing it has to put the diagram back.
   */
  drawPainReliefDiagram = () => {
    if (!this.sigCanvas) return;
    const context = this.sigCanvas.getCanvas().getContext("2d");
    const image = new Image();
    image.src = PainRelief;
    image.onload = () => {
      context.drawImage(image, 0, 0, 652, 446);
    };
  };

  componentDidMount() {
    this.setState({
      id: this.props.match.params.id,
    });

    // Before any mode-specific branching: every path needs the diagram, and the
    // kiosk path returns early.
    this.drawPainReliefDiagram();

    if (this.isKioskMode()) {
      this.loadKioskPrefill();
      return;
    }

    if (
      this.props.match.params.admin === "admin" ||
      this.props.match.params.admin === "reassessment"
    ) {
      // console.log("THIS IS THE ADMIN VIEW");
      let patient = this.getPatientByID(this.props.match.params.id);
      patient.then((patient) => {
        let general;
        // console.log(this.props.match.params.index);
        // console.log(patient.data.intake);

        if (this.props.match.params.index) {
          general = patient.data.intake.history[this.props.match.params.index];
        } else {
          general = patient.data.intake.general;
        }

        const consentSnapshots = general.consentAnswers || {};
        const consentVersions = general.consentVersions || {};
        const consentSubmittedAt = general.consentSubmittedAt || null;
        const isHistoricalRecord = Boolean(this.props.match.params.index);
        const legacySubmittedAt =
          consentSubmittedAt || LEGACY_CONSENT_FALLBACK_DATE;

        const legacyConsentSnapshots = {
          [CONSENT_TYPES.ACUPUNCTURE]: legacyFieldsToSnapshot(
            CONSENT_TYPES.ACUPUNCTURE,
            general,
            legacySubmittedAt,
          ),
          [CONSENT_TYPES.OSTEOPATHY]: legacyFieldsToSnapshot(
            CONSENT_TYPES.OSTEOPATHY,
            general,
            legacySubmittedAt,
          ),
          [CONSENT_TYPES.MASSAGE]: legacyFieldsToSnapshot(
            CONSENT_TYPES.MASSAGE,
            general,
            legacySubmittedAt,
          ),
          [CONSENT_TYPES.TELUS]: legacyFieldsToSnapshot(
            CONSENT_TYPES.TELUS,
            general,
            legacySubmittedAt,
          ),
          [CONSENT_TYPES.SENSITIVE_AREAS]: legacyFieldsToSnapshot(
            CONSENT_TYPES.SENSITIVE_AREAS,
            general,
            legacySubmittedAt,
          ),
          [CONSENT_TYPES.REIKI]: legacyFieldsToSnapshot(
            CONSENT_TYPES.REIKI,
            general,
            legacySubmittedAt,
          ),
          [CONSENT_TYPES.NATUROPATHIC]: legacyFieldsToSnapshot(
            CONSENT_TYPES.NATUROPATHIC,
            general,
            legacySubmittedAt,
          ),
          [CONSENT_TYPES.PHYSIOTHERAPY]: legacyFieldsToSnapshot(
            CONSENT_TYPES.PHYSIOTHERAPY,
            general,
            legacySubmittedAt,
          ),
          [CONSENT_TYPES.CHIROPRACTOR]: legacyFieldsToSnapshot(
            CONSENT_TYPES.CHIROPRACTOR,
            general,
            legacySubmittedAt,
          ),
          [CONSENT_TYPES.HOMEOPATHIC]: legacyFieldsToSnapshot(
            CONSENT_TYPES.HOMEOPATHIC,
            general,
            legacySubmittedAt,
          ),
          [CONSENT_TYPES.GENERAL]: legacyFieldsToSnapshot(
            CONSENT_TYPES.GENERAL,
            general,
            legacySubmittedAt,
          ),
        };

        const resolvedConsentSnapshots =
          Object.keys(consentSnapshots).length > 0
            ? consentSnapshots
            : legacyConsentSnapshots;

        // console.log("gotten patient", general);

        this.setState({
          // intake
          firstName: general.firstName,
          lastName: general.lastName,
          email: general.email,
          dob: general.dob,
          addressStreet: general.addressStreet,
          addressCity: general.addressCity,
          addressPostal: general.addressPostal,
          gender: general.gender,
          occupation: general.occupation,
          cellPhone: general.cellPhone,
          homePhone: general.homePhone,
          emergencyContact: general.emergencyContact,
          emergencyContactTel: general.emergencyContactTel,
          familyPhysicianName: general.familyPhysicianName,
          familyPhysicianPhone: general.familyPhysicianPhone,
          familyPhysicianAddress: general.familyPhysicianAddress,
          referred: general.referred,
          maritalStatus: general.maritalStatus,
          noDependants: general.noDependants,
          insurance: general.insurance,
          otherTreatment: general.otherTreatment,
          healthConditionRequiringTreatment:
            general.healthConditionRequiringTreatment,
          onMedication: general.onMedication,
          travel: general.travel,
          allergies: general.allergies,
          surgery: general.surgery,
          injury: general.injury,
          pacemaker: general.pacemaker,
          metal: general.metal,
          highBloodPressure: general.highBloodPressure,
          lowBloodPressure: general.lowBloodPressure,
          chronicCongestiveHeartFailure: general.chronicCongestiveHeartFailure,
          heartAttack: general.heartAttack,
          phlebitis: general.phlebitis,
          heartSurgery: general.heartSurgery,
          heartDisease: general.heartDisease,
          stroke: general.stroke,
          strokeWhen: general.strokeWhen,
          poorCirculation: general.poorCirculation,
          familyHistoryCario: general.familyHistoryCario,
          chronicCough: general.chronicCough,
          shortnessOfBreath: general.shortnessOfBreath,
          bronchitis: general.bronchitis,
          asthma: general.asthma,
          familyHistoryResp: general.familyHistoryResp,
          poorDigestion: general.poorDigestion,
          IBS: general.IBS,
          constipation: general.constipation,
          liver: general.liver,
          kidney: general.kidney,
          headaches: general.headaches,
          migraines: general.migraines,
          visionProblems: general.visionProblems,
          visionLoss: general.visionLoss,
          earProblems: general.earProblems,
          hearingLoss: general.hearingLoss,
          pain: general.pain,
          stiffness: general.stiffness,
          swelling: general.swelling,
          limitedMotion: general.limitedMotion,
          fatigue: general.fatigue,
          osteoarthritis: general.osteoarthritis,
          backPainUpper: general.backPainUpper,
          backPainMid: general.backPainMid,
          backPainLower: general.backPainLower,
          shoulderPain: general.shoulderPain,
          hepA: general.hepA,
          hepB: general.hepB,
          hepC: general.hepC,
          TB: general.TB,
          HIV: general.HIV,
          herpes: general.herpes,
          infectionsOther: general.infectionsOther,
          sensitiveSkin: general.sensitiveSkin,
          rashes: general.rashes,
          acne: general.acne,
          coldSores: general.coldSores,
          bleedingDisorder: general.bleedingDisorder,
          bruiseEasily: general.bruiseEasily,
          varicoseVeins: general.varicoseVeins,
          deepVeinThrombosis: general.deepVeinThrombosis,
          eczema: general.eczema,
          tattoos: general.tattoos,
          lossOfSensation: general.lossOfSensation,
          diabetes: general.diabetes,
          epilepsy: general.epilepsy,
          cancer: general.cancer,
          multipleSclerosis: general.multipleSclerosis,
          arthritis: general.arthritis,
          familyHistoryArthritis: general.familyHistoryArthritis,
          pregnant: general.pregnant,
          menstruation: general.menstruation,
          menopause: general.menopause,
          generalHealthStatus: general.generalHealthStatus,
          generalStressLevels: general.generalStressLevels,
          regularMeals: general.regularMeals,
          irregularEating: general.irregularEating,
          caffeine: general.caffeine,
          smoke: general.smoke,
          exercise: general.exercise,
          previousMassage: general.previousMassage,
          previousChiro: general.previousChiro,
          previousPhysio: general.previousPhysio,
          previousAcu: general.previousAcu,
          previousOsteo: general.previousOsteo,
          previousPsycho: general.previousPsycho,
          previousNaturopathic: general.previousNaturopathic,
          previousHomeopathic: general.previousHomeopathic,
          dateOfLastFullPhysical: general.dateOfLastFullPhysical,
          otherMedicalConditions: general.otherMedicalConditions,
          internalPins: general.internalPins,
          dentalSurgery: general.dentalSurgery,
          ofSpecialNote: general.ofSpecialNote,
          painReliefDiagram: general.painReliefDiagram,
          additionalInfo: general.additionalInfo,
          consentAcupuncture: general.consentAcupuncture,
          consentBleedEasily: general.consentBleedEasily,
          consentPregnant: general.consentPregnant,
          consentHIV: general.consentHIV,
          consentPacemaker: general.consentPacemaker,
          consentMetal: general.consentMetal,
          sigAcu: general.sigAcu,
          consentOsteopathy: general.consentOsteopathy,
          sigOsteo: general.sigOsteo,
          osteo_temporarySoreness: general.osteo_temporarySoreness || false,
          osteo_pressure: general.osteo_pressure || false,
          osteo_strenuousActivity: general.osteo_strenuousActivity || false,
          osteo_communicateDiscomfort:
            general.osteo_communicateDiscomfort || false,
          osteo_noSpecificOutcome: general.osteo_noSpecificOutcome || false,
          consentMassage: general.consentMassage,
          sigMassage: general.sigMassage,
          consentTelus: general.consentTelus,
          sigTelus: general.sigTelus,
          consentSensitive: general.consentSensitive,
          sigSensitive: general.sigSensitive,
          consentNaturopathic: general.consentNaturopathic,
          sigNaturopathic: general.sigNaturopathic,
          consentReiki: general.consentReiki,
          sigReiki: general.sigReiki,
          reikiConsentAndWaiver: general.reikiConsentAndWaiver,
          reikiTestimonialDisclaimer: general.reikiTestimonialDisclaimer,
          reikiAssumptionOfRisk: general.reikiAssumptionOfRisk,
          reikiGoverningLaw: general.reikiGoverningLaw,
          reikiExclusiveJurisdiction: general.reikiExclusiveJurisdiction,
          // Massage v2 checkboxes (if present in legacy/general record)
          massage_postTreatmentSoreness:
            general.massage_postTreatmentSoreness || false,
          massage_deepTissue: general.massage_deepTissue || false,
          massage_strenuousActivity: general.massage_strenuousActivity || false,
          massage_communicateDiscomfort:
            general.massage_communicateDiscomfort || false,
          massage_noSpecificOutcome: general.massage_noSpecificOutcome || false,
          consentAcceptTerms: general.consentAcceptTerms,
          primaryCoverage: general.primaryCoverage,
          planMember: general.planMember,
          policyNumber: general.policyNumber,
          coverageCert: general.coverageCert,
          canadaLife: general.canadaLife,
          // naturopath
          consentNaturopathic: general.consentNaturopathic,
          // naturopathic specific fields
          currentHealthCareProviders: general.currentHealthCareProviders,
          describeYourHealthConcerns: general.describeYourHealthConcerns,
          currentSupplements: general.currentSupplements,
          listFamilyHistory: general.listFamilyHistory,
          Diet_Restrictions: general.Diet_Restrictions,
          Diet_AdditionalComments: general.Diet_AdditionalComments,
          Diet_RateYourEnergy: general.Diet_RateYourEnergy,
          Diet_RateYourStress: general.Diet_RateYourStress,
          Diet_BiggestSourceOfStress: general.Diet_BiggestSourceOfStress,
          Exercise_ActivityLevel: general.Exercise_ActivityLevel,
          Exercise_TypeofActivity: general.Exercise_TypeofActivity,
          Exercise_OtherRelevantInfo: general.Exercise_OtherRelevantInfo,
          // physical therapy
          consentPhysiotherapy: general.consentPhysiotherapy,
          // chiropractor
          consentChiropractor: general.consentChiropractor,
          // homeopathic
          consentHomeopathic: general.consentHomeopathic,
          // general consent forms
          //  accuracy of information
          Accuracy_IAgree: general.Accuracy_IAgree,
          //  cancellation policy
          CancellationPolicy_IAgree: general.CancellationPolicy_IAgree,
          //  email communication
          EmailCommunication_IAgree: general.EmailCommunication_IAgree,
          //  privacy policy
          PrivacyPolicy_IAgree: general.PrivacyPolicy_IAgree,
          //  signatory
          IWillBeSigning: general.IWillBeSigning,
          substituteSignature: general.substituteSignature,
          substituteSignatureName: general.substituteSignatureName,
          consentSnapshots: resolvedConsentSnapshots,
          consentVersions,
          consentSubmittedAt,
          isHistoricalRecord,
        });
        this.safeLoadCanvasData(this.sigCanvas, general.painReliefDiagram, {
          width: 652,
          height: 446,
        });

        this.safeLoadCanvasData(this.consentAcupunctureSig, general.sigAcu, {
          width: 530,
          height: 240,
        });

        this.safeLoadCanvasData(this.consentOsteoSig, general.sigOsteo, {
          width: 530,
          height: 240,
        });

        this.safeLoadCanvasData(this.consentMassageSig, general.sigMassage, {
          width: 530,
          height: 240,
        });

        this.safeLoadCanvasData(this.consentTelusSig, general.sigTelus, {
          width: 530,
          height: 240,
        });

        this.safeLoadCanvasData(
          this.consentSensitiveSig,
          general.sigSensitive,
          {
            width: 530,
            height: 240,
          },
        );

        this.safeLoadCanvasData(
          this.consentNaturopathicSig,
          general.sigNaturopathic,
          {
            width: 530,
            height: 240,
          },
        );

        this.safeLoadCanvasData(this.consentReikiSig, general.sigReiki, {
          width: 530,
          height: 240,
        });

        this.safeLoadCanvasData(this.consentGeneralSig, general.sigGeneral, {
          width: 530,
          height: 240,
        });
      });
    }
  }

  /**
   * Kiosk prefill.
   *
   * Default (no station, or a first visit): identity and contact only. A
   * returning patient retypes address and date of birth and answers the health
   * history fresh — blank clinical fields are better clinically, since a
   * prefilled checkbox biases a reassessment toward "same as before".
   *
   * When the tablet is signed in as a station AND this is a reassessment, the
   * server allows the prior assessment to be pulled in so the patient edits
   * only what changed. Signatures and consent are never carried over — those
   * are re-collected fresh every visit (the server withholds them). If that
   * clinical read is not permitted (no station at verify time, or not actually
   * a reassessment) the server returns 403 and we fall back to the identity
   * prefill, so nothing is worse than before.
   */
  async loadKioskPrefill() {
    const { token, reassessment } = kiosk.readSession();
    if (!token) {
      // No verified session — send them back to confirm their phone number.
      this.props.history.push("/sign_in");
      return;
    }

    if (reassessment && kiosk.readStationToken()) {
      try {
        const { general } = await kiosk.fetchReassessment(token);
        const prefill = {};
        for (const [key, value] of Object.entries(general || {})) {
          if (this.formFieldKeys.has(key)) prefill[key] = value;
        }
        // The pain-location drawing is a canvas, not an input — draw the prior
        // marks onto it once state has applied, mirroring the staff path. The
        // saved PNG already includes the body outline, so it replaces the blank
        // template drawn on mount.
        this.setState(prefill, () => {
          this.safeLoadCanvasData(this.sigCanvas, general && general.painReliefDiagram, {
            width: 652,
            height: 446,
          });
        });
        return;
      } catch (error) {
        // 401 means the visit token itself is gone — re-verify. Anything else
        // (403: no clinical grant / not a reassessment) falls through to the
        // identity-only prefill below.
        if (error.status === 401) {
          kiosk.clearSession();
          this.props.history.push("/sign_in");
          return;
        }
      }
    }

    try {
      const { general } = await kiosk.fetchIntake(token);
      const prefill = {};
      for (const field of KIOSK_PREFILL_FIELDS) {
        if (general && general[field] !== undefined) {
          prefill[field] = general[field];
        }
      }
      this.setState(prefill);
    } catch (error) {
      // An expired or rejected token means the patient must verify again.
      kiosk.clearSession();
      this.props.history.push("/sign_in");
    }
  }

  getPatientByID(patientID) {
    var promise = new Promise((resolve) => {
      var payload = patientID;
      this.getPatientReq(resolve, payload);
    });
    return promise;
  }

  getPatientReq(resolve, payload) {
    // Staff path only; the kiosk uses loadKioskPrefill().
    client
      .get("/patients/" + payload)
      .then((response) => {
        // console.log(response)
        // console.log("get request")
        if (response.data.successful === false) {
          // console.log("could not get patient")
          var errorMsg = response.data.reason;
          resolve(errorMsg);
        } else {
          resolve(response);
          // console.log(response);
          // console.log('got patient')
        }
      })
      .catch((error) => {
        // console.log(error)
        // console.log("get request error")
        var errorMsg = "Missing data";
        // Should send a response of 400 ***
        resolve(errorMsg);
      });
  }

  clear = () => {
    this.sigCanvas.clear();
    this.drawPainReliefDiagram();
  };

  clearAcu = () => {
    this.consentAcupunctureSig.clear();
  };
  clearOsteo = () => {
    this.consentOsteoSig.clear();
  };
  clearMassage = () => {
    this.consentMassageSig.clear();
  };
  clearTelus = () => {
    this.consentTelusSig.clear();
  };
  clearSensitive = () => {
    this.consentSensitiveSig.clear();
  };
  clearNaturopathic = () => {
    this.consentNaturopathicSig.clear();
  };
  clearReiki = () => {
    this.consentReikiSig.clear();
  };
  clearGeneral = () => {
    this.consentGeneralSig.clear();
  };

  buildConsentSubmissionContext = (submittedAt) => {
    const consentTypes = [
      CONSENT_TYPES.ACUPUNCTURE,
      CONSENT_TYPES.OSTEOPATHY,
      CONSENT_TYPES.MASSAGE,
      CONSENT_TYPES.TELUS,
      CONSENT_TYPES.SENSITIVE_AREAS,
      CONSENT_TYPES.REIKI,
      CONSENT_TYPES.NATUROPATHIC,
      CONSENT_TYPES.PHYSIOTHERAPY,
      CONSENT_TYPES.CHIROPRACTOR,
      CONSENT_TYPES.HOMEOPATHIC,
      CONSENT_TYPES.GENERAL,
    ];

    const consentAnswers = {};
    const consentVersions = {};

    consentTypes.forEach((consentType) => {
      const snapshot = createConsentSnapshot(
        consentType,
        this.state,
        submittedAt,
      );
      consentAnswers[consentType] = snapshot;
      consentVersions[consentType] = snapshot.versionId;
    });

    return { consentAnswers, consentVersions };
  };

  handleCheckBoxChange = (event) => {
    this.setState({
      [event.target.name]: event.target.checked,
    });
  };

  getConsentVersionMetadata = (consentType) => {
    const snapshot = this.state.consentSnapshots?.[consentType];
    if (!snapshot) {
      return null;
    }

    if (!snapshot.submittedAt) {
      const legacyVersion = getConsentVersionAtDate(
        consentType,
        LEGACY_CONSENT_FALLBACK_DATE,
      );

      return legacyVersion
        ? {
            versionId: legacyVersion.versionId,
            submittedAt: null,
          }
        : null;
    }

    return {
      versionId: snapshot.versionId,
      submittedAt: snapshot.submittedAt,
    };
  };

  handleConsentChange = (fieldName, value) => {
    this.setState({
      [fieldName]: value,
    });
  };

  handleInputChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleEmailChange(event) {
    this.setState({ email: event.target.value });
  }

  /* Attempt to log in the user upon submit. */
  handleSubmit(event) {
    this.intakeSubmit().then((errorMsg) => {
      // console.log("submit hit");
      // Redirect and save username is no errors with sign up.
    });
  }

  intakeSubmit() {
    var promise = new Promise((resolve) => {
      const consentSubmittedAt = new Date().toISOString();
      const { consentAnswers, consentVersions } =
        this.buildConsentSubmissionContext(consentSubmittedAt);

      var payload = {
        id: this.state.id,
        general: {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          email: this.state.email,
          dob: this.state.dob,
          addressStreet: this.state.addressStreet,
          addressCity: this.state.addressCity,
          addressPostal: this.state.addressPostal,
          gender: this.state.gender,
          occupation: this.state.occupation,
          cellPhone: this.state.cellPhone,
          homePhone: this.state.homePhone,
          emergencyContact: this.state.emergencyContact,
          emergencyContactTel: this.state.emergencyContactTel,
          familyPhysicianName: this.state.familyPhysicianName,
          familyPhysicianPhone: this.state.familyPhysicianPhone,
          familyPhysicianAddress: this.state.familyPhysicianAddress,
          referred: this.state.referred,
          maritalStatus: this.state.maritalStatus,
          noDependants: this.state.noDependants,
          insurance: this.state.insurance,
          otherTreatment: this.state.otherTreatment,
          healthConditionRequiringTreatment:
            this.state.healthConditionRequiringTreatment,
          onMedication: this.state.onMedication,
          travel: this.state.travel,
          allergies: this.state.allergies,
          surgery: this.state.surgery,
          injury: this.state.injury,
          pacemaker: this.state.pacemaker,
          metal: this.state.metal,
          highBloodPressure: this.state.highBloodPressure,
          lowBloodPressure: this.state.lowBloodPressure,
          chronicCongestiveHeartFailure:
            this.state.chronicCongestiveHeartFailure,
          heartAttack: this.state.heartAttack,
          phlebitis: this.state.phlebitis,
          heartSurgery: this.state.heartSurgery,
          heartDisease: this.state.heartDisease,
          stroke: this.state.stroke,
          strokeWhen: this.state.strokeWhen,
          poorCirculation: this.state.poorCirculation,
          familyHistoryCario: this.state.familyHistoryCario,
          chronicCough: this.state.chronicCough,
          shortnessOfBreath: this.state.shortnessOfBreath,
          bronchitis: this.state.bronchitis,
          asthma: this.state.asthma,
          familyHistoryResp: this.state.familyHistoryResp,
          poorDigestion: this.state.poorDigestion,
          IBS: this.state.IBS,
          constipation: this.state.constipation,
          liver: this.state.liver,
          kidney: this.state.kidney,
          headaches: this.state.headaches,
          migraines: this.state.migraines,
          visionProblems: this.state.visionProblems,
          visionLoss: this.state.visionLoss,
          earProblems: this.state.earProblems,
          hearingLoss: this.state.hearingLoss,
          pain: this.state.pain,
          stiffness: this.state.stiffness,
          swelling: this.state.swelling,
          limitedMotion: this.state.limitedMotion,
          fatigue: this.state.fatigue,
          osteoarthritis: this.state.osteoarthritis,
          backPainUpper: this.state.backPainUpper,
          backPainMid: this.state.backPainMid,
          backPainLower: this.state.backPainLower,
          shoulderPain: this.state.shoulderPain,
          hepA: this.state.hepA,
          hepB: this.state.hepB,
          hepC: this.state.hepC,
          TB: this.state.TB,
          HIV: this.state.HIV,
          herpes: this.state.herpes,
          infectionsOther: this.state.infectionsOther,
          sensitiveSkin: this.state.sensitiveSkin,
          rashes: this.state.rashes,
          acne: this.state.acne,
          coldSores: this.state.coldSores,
          bleedingDisorder: this.state.bleedingDisorder,
          bruiseEasily: this.state.bruiseEasily,
          varicoseVeins: this.state.varicoseVeins,
          deepVeinThrombosis: this.state.deepVeinThrombosis,
          eczema: this.state.eczema,
          tattoos: this.state.tattoos,
          lossOfSensation: this.state.lossOfSensation,
          diabetes: this.state.diabetes,
          epilepsy: this.state.epilepsy,
          cancer: this.state.cancer,
          multipleSclerosis: this.state.multipleSclerosis,
          arthritis: this.state.arthritis,
          familyHistoryArthritis: this.state.familyHistoryArthritis,
          pregnant: this.state.pregnant,
          menstruation: this.state.menstruation,
          menopause: this.state.menopause,
          generalHealthStatus: this.state.generalHealthStatus,
          generalStressLevels: this.state.generalStressLevels,
          regularMeals: this.state.regularMeals,
          irregularEating: this.state.irregularEating,
          caffeine: this.state.caffeine,
          smoke: this.state.smoke,
          exercise: this.state.exercise,
          previousMassage: this.state.previousMassage,
          previousChiro: this.state.previousChiro,
          previousPhysio: this.state.previousPhysio,
          previousAcu: this.state.previousAcu,
          previousOsteo: this.state.previousOsteo,
          previousPsycho: this.state.previousPsycho,
          previousNaturopathic: this.state.previousNaturopathic,
          previousHomeopathic: this.state.previousHomeopathic,
          dateOfLastFullPhysical: this.state.dateOfLastFullPhysical,
          otherMedicalConditions: this.state.otherMedicalConditions,
          internalPins: this.state.internalPins,
          dentalSurgery: this.state.dentalSurgery,
          ofSpecialNote: this.state.ofSpecialNote,
          painReliefDiagram: this.sigCanvas
            .getCanvas()
            .toDataURL("image/png", 1.0),
          additionalInfo: this.state.additionalInfo,
          consentAcupuncture: this.state.consentAcupuncture,
          consentBleedEasily: this.state.consentBleedEasily,
          consentPregnant: this.state.consentPregnant,
          consentHIV: this.state.consentHIV,
          consentPacemaker: this.state.consentPacemaker,
          consentMetal: this.state.consentMetal,
          sigAcu: null,
          consentOsteopathy: this.state.consentOsteopathy,
          sigOsteo: null,
          osteo_temporarySoreness: this.state.osteo_temporarySoreness,
          osteo_pressure: this.state.osteo_pressure,
          osteo_strenuousActivity: this.state.osteo_strenuousActivity,
          osteo_communicateDiscomfort: this.state.osteo_communicateDiscomfort,
          osteo_noSpecificOutcome: this.state.osteo_noSpecificOutcome,
          consentMassage: this.state.consentMassage,
          sigMassage: null,
          consentTelus: this.state.consentTelus,
          sigTelus: null,
          consentSensitive: this.state.consentSensitive,
          sigSensitive: null,
          consentNaturopathic: this.state.consentNaturopathic,
          sigNaturopathic: null,
          consentReiki: this.state.consentReiki,
          reikiConsentAndWaiver: this.state.reikiConsentAndWaiver,
          reikiTestimonialDisclaimer: this.state.reikiTestimonialDisclaimer,
          reikiAssumptionOfRisk: this.state.reikiAssumptionOfRisk,
          reikiGoverningLaw: this.state.reikiGoverningLaw,
          reikiExclusiveJurisdiction: this.state.reikiExclusiveJurisdiction,
          sigReiki: null,
          consentAcceptTerms: this.state.consentAcceptTerms,
          primaryCoverage: this.state.primaryCoverage,
          planMember: this.state.planMember,
          policyNumber: this.state.policyNumber,
          coverageCert: this.state.coverageCert,
          canadaLife: this.state.canadaLife,
          // naturopath
          consentNaturopathic: this.state.consentNaturopathic,
          // naturopathic specific fields
          currentHealthCareProviders: this.state.currentHealthCareProviders,
          describeYourHealthConcerns: this.state.describeYourHealthConcerns,
          currentSupplements: this.state.currentSupplements,
          listFamilyHistory: this.state.listFamilyHistory,
          Diet_Restrictions: this.state.Diet_Restrictions,
          Diet_AdditionalComments: this.state.Diet_AdditionalComments,
          Diet_RateYourEnergy: this.state.Diet_RateYourEnergy,
          Diet_RateYourStress: this.state.Diet_RateYourStress,
          Diet_BiggestSourceOfStress: this.state.Diet_BiggestSourceOfStress,
          Exercise_ActivityLevel: this.state.Exercise_ActivityLevel,
          Exercise_TypeofActivity: this.state.Exercise_TypeofActivity,
          Exercise_OtherRelevantInfo: this.state.Exercise_OtherRelevantInfo,
          // physical therapy
          consentPhysiotherapy: this.state.consentPhysiotherapy,
          // chiropractor
          consentChiropractor: this.state.consentChiropractor,
          // homeopathic
          consentHomeopathic: this.state.consentHomeopathic,
          // Massage v2 flat fields for backward compatibility
          massage_postTreatmentSoreness:
            this.state.massage_postTreatmentSoreness,
          massage_deepTissue: this.state.massage_deepTissue,
          massage_strenuousActivity: this.state.massage_strenuousActivity,
          massage_communicateDiscomfort:
            this.state.massage_communicateDiscomfort,
          massage_noSpecificOutcome: this.state.massage_noSpecificOutcome,
          consentSubmittedAt,
          consentVersions,
          consentAnswers,
          // general consent forms
          //  accuracy of information
          Accuracy_IAgree: this.state.Accuracy_IAgree,
          //  cancellation policy
          CancellationPolicy_IAgree: this.state.CancellationPolicy_IAgree,
          //  email communication
          EmailCommunication_IAgree: this.state.EmailCommunication_IAgree,
          //  privacy policy
          PrivacyPolicy_IAgree: this.state.PrivacyPolicy_IAgree,
          sigGeneral: null, // general consent signature
          //  signatory
          IWillBeSigning: this.state.IWillBeSigning,
          substituteSignature: this.state.substituteSignature,
          substituteSignatureName: this.state.substituteSignatureName,
        },
      };

      try {
        payload.general.sigAcu = this.consentAcupunctureSig
          .getCanvas()
          .toDataURL("image/png", 1.0);
      } catch (err) {
        // console.log("no acu sig")
      }
      try {
        payload.general.sigOsteo = this.consentOsteoSig
          .getCanvas()
          .toDataURL("image/png", 1.0);
      } catch (err) {
        // console.log("no osteo sig")
      }
      try {
        payload.general.sigMassage = this.consentMassageSig
          .getCanvas()
          .toDataURL("image/png", 1.0);
      } catch (err) {
        // console.log("no massage sig")
      }
      try {
        payload.general.sigTelus = this.consentTelusSig
          .getCanvas()
          .toDataURL("image/png", 1.0);
      } catch (err) {
        // console.log("no telus sig")
      }
      try {
        payload.general.sigSensitive = this.consentSensitiveSig
          .getCanvas()
          .toDataURL("image/png", 1.0);
      } catch (err) {
        // console.log("no telus sig")
      }
      try {
        payload.general.sigNaturopathic = this.consentNaturopathicSig
          .getCanvas()
          .toDataURL("image/png", 1.0);
      } catch (err) {
        // console.log("no telus sig")
      }
      try {
        payload.general.sigReiki = this.consentReikiSig
          .getCanvas()
          .toDataURL("image/png", 1.0);
      } catch (err) {
        // console.log("no massage sig")
      }
      try {
        payload.general.sigGeneral = this.consentGeneralSig
          .getCanvas()
          .toDataURL("image/png", 1.0);
      } catch (err) {
        // console.log("no massage sig")
      }
      // console.log("payload", payload)
      if (this.props.match.params.admin === "admin") {
        // if this is admin view, then send an index of -1 if this is the current form
        // or the history index.
        if (this.props.match.params.index) {
          payload.index = Number(this.props.match.params.index); // add 'index' property to payload
        } else {
          payload.index = -1; // add 'index' property to payload
        }
      }

      this.intakeSubmitReq(resolve, payload);
    });
    return promise;
  }

  intakeSubmitReq(resolve, payload) {
    // On the kiosk the patient id comes from the token claims, not the payload —
    // a kiosk token can only ever write to its own visit's patient.
    if (this.isKioskMode()) {
      const { token } = kiosk.readSession();
      kiosk
        .submitIntake(token, payload.general)
        .then(() => {
          kiosk.clearSession();
          resolve("");
          this.props.history.push("/sign_in/");
        })
        .catch((error) => {
          resolve(error.message || "Missing data");
          this.setState({ displayError: true });
        });
      return;
    }

    client
      .post("/patients/intake", payload)
      .then((response) => {
        // console.log(response)
        // console.log("post request")
        if (response.data.successful === false) {
          // console.log("intake failed")
          var errorMsg = response.data.reason;
          resolve(errorMsg);
        } else {
          resolve("");
          // console.log(response);
          // console.log('intake succeeded!')
          if (this.props.match.params.admin === "admin") {
            this.props.history.push("/patient/" + this.props.match.params.id);
          } else {
            this.props.history.push("/sign_in/");
          }
        }
      })
      .catch((error) => {
        // console.log(error)
        // console.log("post request error")
        var errorMsg = "Missing data";
        // Should send a response of 400 ***
        resolve(errorMsg);
      });
  }

  render() {
    return (
      <div>
        <ThemeProvider theme={theme}>
          <Grid
            container
            direction="row"
            justify="left"
            alignItems="left"
            style={{ marginTop: 0, padding: 70 }}
          >
            <Grid item xs={12} sm={12}>
              {this.props.match.params.admin === "admin" ? (
                <>
                  <Typography
                    variant="h4"
                    style={{
                      textAlign: "left",
                      marginTop: 20,
                      marginBottom: 10,
                    }}
                  >
                    Intake Form
                  </Typography>
                  {this.props.match.params.index ? (
                    <>
                      This is Form #{Number(this.props.match.params.index) + 1}
                    </>
                  ) : (
                    <>This is the current intake form</>
                  )}
                </>
              ) : (
                <>
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    WELCOME TO
                  </Typography>
                  <Typography
                    variant="h4"
                    style={{ textAlign: "left", marginTop: 20 }}
                  >
                    The Appleby Wellness Clinic
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    style={{ textAlign: "left", marginTop: 20 }}
                  >
                    Please answer all of the questions below. If you have any
                    questions or would like clarification, please ask the front
                    desk.
                  </Typography>
                </>
              )}
              <br />
              <hr style={{ opacity: "20%" }} />
              <br />
              <Typography variant="overline" style={{ textAlign: "left" }}>
                Patient Information
              </Typography>
              <Grid container style={{ marginBottom: 20 }} spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    ref="firstName"
                    label="First Name"
                    id="margin-none"
                    className="firstName"
                    onChange={this.handleInputChange}
                    style={{ width: "100%" }}
                    variant={"outlined"}
                    name="firstName"
                    value={this.state.firstName}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    ref="lastName"
                    label="Last Name"
                    id="margin-none"
                    onChange={this.handleInputChange}
                    style={{ width: "100%" }}
                    variant={"outlined"}
                    name="lastName"
                    value={this.state.lastName}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="date"
                    label="Birth Date"
                    type="date"
                    defaultValue="2000-00-00"
                    variant={"outlined"}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    style={{ width: "100%" }}
                    onChange={this.handleInputChange}
                    name="dob"
                    value={this.state.dob}
                  />
                </Grid>
              </Grid>
              <Grid container style={{ marginBottom: 20 }} spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    ref="street"
                    label="Occupation"
                    id="margin-none"
                    onChange={this.handleInputChange}
                    style={{ width: "100%" }}
                    variant={"outlined"}
                    name="occupation"
                    value={this.state.occupation}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" style={{ width: "100%" }}>
                    <InputLabel id="demo-simple-select-outlined-label">
                      Gender
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      // value={}
                      onChange={this.handleInputChange}
                      label="Gender"
                      name="gender"
                      value={this.state.gender}
                    >
                      <MenuItem value="Male">Male</MenuItem>
                      <MenuItem value="Female">Female</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    ref="maritalStatus"
                    label="Marital Status"
                    id="margin-none"
                    onChange={this.handleInputChange}
                    style={{ width: "100%" }}
                    variant={"outlined"}
                    name="maritalStatus"
                    value={this.state.maritalStatus}
                  />
                </Grid>
              </Grid>
              <Grid container style={{ marginBottom: 20 }} spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    ref="dependant"
                    label="No. of Dependents"
                    id="margin-none"
                    onChange={this.handleInputChange}
                    style={{ width: "100%" }}
                    variant={"outlined"}
                    name="noDependants"
                    value={this.state.noDependants}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    ref="insurance"
                    label="Insurance Company"
                    id="margin-none"
                    onChange={this.handleInputChange}
                    style={{ width: "100%" }}
                    variant={"outlined"}
                    name="insurance"
                    value={this.state.insurance}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    ref="referred"
                    label="Referred By"
                    id="margin-none"
                    onChange={this.handleInputChange}
                    style={{ width: "100%" }}
                    variant={"outlined"}
                    helperText="internet/friend/etc"
                    name="referred"
                    value={this.state.referred}
                  />
                </Grid>
              </Grid>
              <Typography variant="overline" style={{ textAlign: "left" }}>
                Address
              </Typography>
              <Grid container style={{ marginBottom: 20 }} spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    ref="street"
                    label="Street"
                    id="margin-none"
                    onChange={this.handleInputChange}
                    style={{ width: "100%" }}
                    variant={"outlined"}
                    name="addressStreet"
                    value={this.state.addressStreet}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    ref="street"
                    label="City"
                    id="margin-none"
                    onChange={this.handleInputChange}
                    style={{ width: "100%" }}
                    variant={"outlined"}
                    name="addressCity"
                    value={this.state.addressCity}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    ref="street"
                    label="Postal Code"
                    id="margin-none"
                    onChange={this.handleInputChange}
                    style={{ width: "100%" }}
                    variant={"outlined"}
                    name="addressPostal"
                    value={this.state.addressPostal}
                  />
                </Grid>
              </Grid>
              <Typography variant="overline" style={{ textAlign: "left" }}>
                Contact Information
              </Typography>
              <Grid container style={{ marginBottom: 20 }} spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    ref="street"
                    label="Email"
                    id="margin-none"
                    onChange={this.handleInputChange}
                    style={{ width: "100%" }}
                    variant={"outlined"}
                    name="email"
                    value={this.state.email}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputMask
                    mask="(999) 999-9999"
                    onChange={this.handleInputChange}
                    disabled={false}
                    maskChar=" "
                    value={this.state.cellPhone}
                  >
                    {() => (
                      <TextField
                        style={{ width: "100%" }}
                        variant={"outlined"}
                        name="cellPhone"
                        label="Cell Phone"
                      />
                    )}
                  </InputMask>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputMask
                    mask="(999) 999-9999"
                    onChange={this.handleInputChange}
                    disabled={false}
                    maskChar=" "
                    value={this.state.homePhone}
                  >
                    {() => (
                      <TextField
                        style={{ width: "100%" }}
                        variant={"outlined"}
                        name="homePhone"
                        label="Home Phone"
                      />
                    )}
                  </InputMask>
                </Grid>
              </Grid>
              <Grid container style={{ marginBottom: 20 }} spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    ref="street"
                    label="Emergency Contact and Relationship"
                    id="margin-none"
                    onChange={this.handleInputChange}
                    style={{ width: "100%" }}
                    variant={"outlined"}
                    name="emergencyContact"
                    value={this.state.emergencyContact}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputMask
                    mask="(999) 999-9999"
                    onChange={this.handleInputChange}
                    disabled={false}
                    maskChar=" "
                    value={this.state.emergencyContactTel}
                  >
                    {() => (
                      <TextField
                        style={{ width: "100%" }}
                        variant={"outlined"}
                        name="emergencyContactTel"
                        label="Tel"
                      />
                    )}
                  </InputMask>
                </Grid>
              </Grid>
              <Typography variant="overline" style={{ textAlign: "left" }}>
                Family Physician
              </Typography>
              <Grid container style={{ marginBottom: 20 }} spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    ref="phys_name"
                    label="Name"
                    id="margin-none"
                    onChange={this.handleInputChange}
                    style={{ width: "100%" }}
                    variant={"outlined"}
                    name="familyPhysicianName"
                    value={this.state.familyPhysicianName}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputMask
                    mask="(999) 999-9999"
                    onChange={this.handleInputChange}
                    disabled={false}
                    maskChar=" "
                    value={this.state.familyPhysicianPhone}
                  >
                    {() => (
                      <TextField
                        style={{ width: "100%" }}
                        variant={"outlined"}
                        name="familyPhysicianPhone"
                        label="Phone #"
                      />
                    )}
                  </InputMask>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    ref="phys_address"
                    label="Address"
                    id="margin-none"
                    onChange={this.handleInputChange}
                    style={{ width: "100%" }}
                    variant={"outlined"}
                    name="familyPhysicianAddress"
                    value={this.state.familyPhysicianAddress}
                  />
                </Grid>
              </Grid>
              <Typography variant="h6" style={{ textAlign: "left" }}>
                Expected services
              </Typography>
              <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                Which of the following services are you planning on receiving
                from Appleby Wellness? If you are unsure, select all.
              </Typography>
              <br />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.consentAcupuncture}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="consentAcupuncture"
                        value={this.state.consentAcupuncture}
                      />
                    }
                    label="Acupuncture/Traditional Chinese Medicine"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.consentOsteopathy}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="consentOsteopathy"
                        value={this.state.consentOsteopathy}
                      />
                    }
                    label="Osteopathy"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.consentMassage}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="consentMassage"
                        value={this.state.consentMassage}
                      />
                    }
                    label="Massage"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.consentReiki}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="consentReiki"
                        value={this.state.consentReiki}
                      />
                    }
                    label="Reiki"
                  />
                  <br />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.consentNaturopathic}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="consentNaturopathic"
                        value={this.state.consentNaturopathic}
                      />
                    }
                    label="Naturopathic"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.consentHomeopathic}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="consentHomeopathic"
                        value={this.state.consentHomeopathic}
                      />
                    }
                    label="Homeopathic"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.consentPhysiotherapy}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="consentPhysiotherapy"
                        value={this.state.consentPhysiotherapy}
                      />
                    }
                    label="Physiotherapy"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.consentChiropractor}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="consentChiropractor"
                        value={this.state.consentChiropractor}
                      />
                    }
                    label="Chiropractor"
                  />
                </Grid>
              </Grid>
              <br />
              <Typography variant="overline" style={{ textAlign: "left" }}>
                Health Questions
              </Typography>
              <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                Are you currently receiving treatment from other health care
                professionals, such as fertility, pediatrics, neurology...?
                Which clinic? How long?
              </Typography>
              <TextField
                id="outlined-multiline-static"
                label="Answer"
                onChange={this.handleInputChange}
                multiline
                rows={3}
                style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                variant="outlined"
                name="otherTreatment"
                value={this.state.otherTreatment}
              />
              <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                Health Condition Required Attention/Reason for Treatment:
              </Typography>
              <TextField
                id="outlined-multiline-static"
                onChange={this.handleInputChange}
                label="Answer"
                multiline
                rows={3}
                style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                variant="outlined"
                name="healthConditionRequiringTreatment"
                value={this.state.healthConditionRequiringTreatment}
              />
              <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                Are you on medications? Yes/No. If yes, for what condition?
              </Typography>
              <TextField
                id="outlined-multiline-static"
                onChange={this.handleInputChange}
                label="Answer"
                multiline
                rows={3}
                style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                variant="outlined"
                name="onMedication"
                value={this.state.onMedication}
              />
              {this.state.consentNaturopathic && (
                <div>
                  <br />
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    Please list your current supplements: (Medication, dose,
                    reason for taking, duration of use.)
                  </Typography>
                  <TextField
                    id="outlined-multiline-static"
                    onChange={this.handleInputChange}
                    label="Answer"
                    multiline
                    rows={3}
                    style={{
                      marginBottom: 20,
                      marginTop: 10,
                      width: "100%",
                    }}
                    variant="outlined"
                    name="currentSupplements"
                    value={this.state.currentSupplements}
                  />
                  <br />
                </div>
              )}
              <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                Did you travel outside of Canada in past 3 months? Where and
                When?
              </Typography>
              <TextField
                id="outlined-multiline-static"
                onChange={this.handleInputChange}
                label="Answer"
                multiline
                rows={3}
                style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                variant="outlined"
                name="travel"
                value={this.state.travel}
              />
              <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                Do you have any allergies? If yes, please specify.
              </Typography>
              <TextField
                id="outlined-multiline-static"
                onChange={this.handleInputChange}
                label="Answer"
                multiline
                rows={3}
                style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                variant="outlined"
                name="allergies"
                value={this.state.allergies}
              />
              <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                Did you have any surgery? Specify date and nature of the
                surgery.
              </Typography>
              <TextField
                id="outlined-multiline-static"
                onChange={this.handleInputChange}
                label="Answer"
                multiline
                rows={3}
                style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                variant="outlined"
                name="surgery"
                value={this.state.surgery}
              />
              <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                Did you have any injury? Specify date and nature of the injury.
              </Typography>
              <TextField
                id="outlined-multiline-static"
                onChange={this.handleInputChange}
                label="Answer"
                multiline
                rows={3}
                style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                variant="outlined"
                name="injury"
                value={this.state.injury}
              />
              <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                Please indicate conditions you are experiencing or have
                experienced. Select the ones you have.
              </Typography>
              <Grid container style={{ marginBottom: 20 }} spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Typography variant="overline" style={{ textAlign: "left" }}>
                    Cardiovascular
                  </Typography>{" "}
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.pacemaker}
                        onChange={this.handleCheckBoxChange}
                        name="pacemaker"
                        color="primary"
                        value={this.state.pacemaker}
                      />
                    }
                    label="Are you wearing a pacemaker?"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.metal}
                        onChange={this.handleCheckBoxChange}
                        name="metal"
                        color="primary"
                        value={this.state.metal}
                      />
                    }
                    label="Metal in your body?"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.highBloodPressure}
                        onChange={this.handleCheckBoxChange}
                        name="highBloodPressure"
                        color="primary"
                        value={this.state.highBloodPressure}
                      />
                    }
                    label="High blood pressure"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.lowBloodPressure}
                        onChange={this.handleCheckBoxChange}
                        name="lowBloodPressure"
                        color="primary"
                        value={this.state.lowBloodPressure}
                      />
                    }
                    label="Low blood pressure"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.chronicCongestiveHeartFailure}
                        onChange={this.handleCheckBoxChange}
                        name="chronicCongestiveHeartFailure"
                        color="primary"
                        value={this.state.chronicCongestiveHeartFailure}
                      />
                    }
                    label="Chronic congestive heart failure"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.heartAttack}
                        onChange={this.handleCheckBoxChange}
                        name="heartAttack"
                        color="primary"
                        value={this.state.heartAttack}
                      />
                    }
                    label="Heart attack"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.phlebitis}
                        onChange={this.handleCheckBoxChange}
                        name="phlebitis"
                        color="primary"
                        value={this.state.phlebitis}
                      />
                    }
                    label="Phlebitis / varicose veins"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.stroke}
                        onChange={this.handleCheckBoxChange}
                        name="stroke"
                        color="primary"
                        value={this.state.stroke}
                      />
                    }
                    label="stroke / CVA"
                  />
                  <br />
                  <TextField
                    id="outlined-multiline-static"
                    onChange={this.handleInputChange}
                    label="Date of stroke"
                    style={{ marginBottom: 10, marginTop: 10, width: "100%" }}
                    variant="outlined"
                    name="strokeWhen"
                    value={this.state.strokeWhen}
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.heartDisease}
                        onChange={this.handleCheckBoxChange}
                        name="heartDisease"
                        color="primary"
                        value={this.state.heartDisease}
                      />
                    }
                    label="Heart Disease"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.heartSurgery}
                        onChange={this.handleCheckBoxChange}
                        name="heartSurgery"
                        color="primary"
                        value={this.state.heartSurgery}
                      />
                    }
                    label="Heart Surgery"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.poorCirculation}
                        onChange={this.handleCheckBoxChange}
                        name="poorCirculation"
                        color="primary"
                        value={this.state.poorCirculation}
                      />
                    }
                    label="Poor circulation"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.familyHistoryCario}
                        onChange={this.handleCheckBoxChange}
                        name="familyHistoryCario"
                        color="primary"
                        value={this.state.familyHistoryCario}
                      />
                    }
                    label="Family history of the above"
                  />{" "}
                  <br />
                  <Typography variant="overline" style={{ textAlign: "left" }}>
                    Respiratory
                  </Typography>{" "}
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.chronicCough}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="chronicCough"
                        value={this.state.chronicCough}
                      />
                    }
                    label="Chronic Cough"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.shortnessOfBreath}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="shortnessOfBreath"
                        value={this.state.shortnessOfBreath}
                      />
                    }
                    label="Shortness of Breath"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.bronchitis}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="bronchitis"
                        value={this.state.bronchitis}
                      />
                    }
                    label="Bronchitis"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.asthma}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="asthma"
                        value={this.state.asthma}
                      />
                    }
                    label="Asthma Emphysema"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.familyHistoryResp}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="familyHistoryResp"
                        value={this.state.familyHistoryResp}
                      />
                    }
                    label="Family history of the above?"
                  />
                  <br />
                  <Typography variant="overline" style={{ textAlign: "left" }}>
                    Digestion
                  </Typography>{" "}
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.poorDigestion}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="poorDigestion"
                        value={this.state.poorDigestion}
                      />
                    }
                    label="Poor digestion"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.IBS}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="IBS"
                        value={this.state.IBS}
                      />
                    }
                    label="IBS"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.constipation}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="constipation"
                        value={this.state.constipation}
                      />
                    }
                    label="Constipation or Diarrhea"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.liver}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="liver"
                        value={this.state.liver}
                      />
                    }
                    label="Liver/Gallbladder"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.kidney}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="kidney"
                        value={this.state.kidney}
                      />
                    }
                    label="Kidney/Bladder"
                  />
                  <br />
                  <Typography variant="overline" style={{ textAlign: "left" }}>
                    Head/Neck
                  </Typography>{" "}
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.headaches}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="headaches"
                        value={this.state.headaches}
                      />
                    }
                    label="History of headaches"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.migraines}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="migraines"
                        value={this.state.migraines}
                      />
                    }
                    label="History of migraines"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.visionProblems}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="visionProblems"
                        value={this.state.visionProblems}
                      />
                    }
                    label="Vision Problems"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.visionLoss}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="visionLoss"
                        value={this.state.visionLoss}
                      />
                    }
                    label="Vision Loss"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.earProblems}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="earProblems"
                        value={this.state.earProblems}
                      />
                    }
                    label="Ear Problems"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.hearingLoss}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="hearingLoss"
                        value={this.state.hearingLoss}
                      />
                    }
                    label="Hearing Loss"
                  />
                  <br />
                  <Typography variant="overline" style={{ textAlign: "left" }}>
                    Muscle and Joint
                  </Typography>{" "}
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.pain}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="pain"
                        value={this.state.pain}
                      />
                    }
                    label="Pain"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.stiffness}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="stiffness"
                        value={this.state.stiffness}
                      />
                    }
                    label="Stiffness"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.swelling}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="swelling"
                        value={this.state.swelling}
                      />
                    }
                    label="Swelling"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.limitedMotion}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="limitedMotion"
                        value={this.state.limitedMotion}
                      />
                    }
                    label="Limited motion"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.fatigue}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="fatigue"
                        value={this.state.fatigue}
                      />
                    }
                    label="Fatigue"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.osteoarthritis}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="osteoarthritis"
                        value={this.state.osteoarthritis}
                      />
                    }
                    label="Osteoarthritis"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.backPainUpper}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="backPainUpper"
                        value={this.state.backPainUpper}
                      />
                    }
                    label="Back pain upper"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.backPainMid}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="backPainMid"
                        value={this.state.backPainMid}
                      />
                    }
                    label="Back pain Mid"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.backPainLower}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="backPainLower"
                        value={this.state.backPainLower}
                      />
                    }
                    label="Back pain lower"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.shoulderPain}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="shoulderPain"
                        value={this.state.shoulderPain}
                      />
                    }
                    label="Shoulder pain"
                  />
                  <br />
                  <Typography variant="overline" style={{ textAlign: "left" }}>
                    Infections
                  </Typography>{" "}
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.hepA}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="hepA"
                        value={this.state.hepA}
                      />
                    }
                    label="Hepatitis A"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.hepB}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="hepB"
                        value={this.state.hepB}
                      />
                    }
                    label="Hepatitis B"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.hepC}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="hepC"
                        value={this.state.hepC}
                      />
                    }
                    label="Hepatitis C"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.TB}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="TB"
                        value={this.state.TB}
                      />
                    }
                    label="TB"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.HIV}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="HIV"
                        value={this.state.HIV}
                      />
                    }
                    label="HIV"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.herpes}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="herpes"
                        value={this.state.herpes}
                      />
                    }
                    label="herpes"
                  />
                  <br />
                  <TextField
                    id="outlined-multiline-static"
                    onChange={this.handleInputChange}
                    label="others"
                    style={{ marginBottom: 10, marginTop: 10, width: "100%" }}
                    variant="outlined"
                    name="infectionsOther"
                    value={this.state.infectionsOther}
                  />
                  <br />
                  <Typography variant="overline" style={{ textAlign: "left" }}>
                    Skin Conditions
                  </Typography>{" "}
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.sensitiveSkin}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="sensitiveSkin"
                        value={this.state.sensitiveSkin}
                      />
                    }
                    label="Sensitive Skin"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.rashes}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="rashes"
                        value={this.state.rashes}
                      />
                    }
                    label="Rashes"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.acne}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="acne"
                        value={this.state.acne}
                      />
                    }
                    label="Acne"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.coldSores}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="coldSores"
                        value={this.state.coldSores}
                      />
                    }
                    label="Cold sores"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.bleedingDisorder}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="bleedingDisorder"
                        value={this.state.bleedingDisorder}
                      />
                    }
                    label="Bleeding Disorder"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.bruiseEasily}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="bruiseEasily"
                        value={this.state.bruiseEasily}
                      />
                    }
                    label="Bruise Easily"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.varicoseVeins}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="varicoseVeins"
                        value={this.state.varicoseVeins}
                      />
                    }
                    label="Varicose veins"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.deepVeinThrombosis}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="deepVeinThrombosis"
                        value={this.state.deepVeinThrombosis}
                      />
                    }
                    label="Deep Vein Thrombosis"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.eczema}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="eczema"
                        value={this.state.eczema}
                      />
                    }
                    label="Eczema/psoriasis"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.tattoos}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="tattoos"
                        value={this.state.tattoos}
                      />
                    }
                    label="Recent tattoos/piercing"
                  />
                  <br />
                  <Typography variant="overline" style={{ textAlign: "left" }}>
                    Other Conditions
                  </Typography>{" "}
                  <br />
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    Loss of sensation, when and where?
                  </Typography>{" "}
                  <br />
                  <TextField
                    id="outlined-multiline-static"
                    onChange={this.handleInputChange}
                    label="Answer"
                    multiline
                    rows={3}
                    style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                    variant="outlined"
                    name="lossOfSensation"
                    value={this.state.lossOfSensation}
                  />
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    diabetes, onset
                  </Typography>{" "}
                  <br />
                  <TextField
                    onChange={this.handleInputChange}
                    id="outlined-multiline-static"
                    label="Answer"
                    multiline
                    rows={3}
                    style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                    variant="outlined"
                    name="diabetes"
                    value={this.state.diabetes}
                  />{" "}
                  <br />
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    cancer, where?
                  </Typography>{" "}
                  <br />
                  <TextField
                    id="outlined-multiline-static"
                    onChange={this.handleInputChange}
                    label="Answer"
                    multiline
                    rows={3}
                    style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                    variant="outlined"
                    name="cancer"
                    value={this.state.cancer}
                  />{" "}
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.epilepsy}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="epilepsy"
                        value={this.state.epilepsy}
                      />
                    }
                    label="Epilepsy"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.multipleSclerosis}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="multipleSclerosis"
                        value={this.state.multipleSclerosis}
                      />
                    }
                    label="Multiple Sclerosis"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.arthritis}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="arthritis"
                        value={this.state.arthritis}
                      />
                    }
                    label="Arthritis"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.familyHistoryArthritis}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="familyHistoryArthritis"
                        value={this.state.familyHistoryArthritis}
                      />
                    }
                    label="Family history of Arthritis?"
                  />
                  {this.state.consentNaturopathic && (
                    <div>
                      <br />
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "left" }}
                      >
                        Family History: Please list any medical conditions your
                        family members may have:
                      </Typography>
                      <TextField
                        id="outlined-multiline-static"
                        onChange={this.handleInputChange}
                        label="Answer"
                        multiline
                        rows={3}
                        style={{
                          marginBottom: 20,
                          marginTop: 10,
                          width: "100%",
                        }}
                        variant="outlined"
                        name="listFamilyHistory"
                        value={this.state.listFamilyHistory}
                      />
                      <br />
                    </div>
                  )}
                  <br />
                  <br />
                  <Typography variant="overline" style={{ textAlign: "left" }}>
                    Women
                  </Typography>{" "}
                  <br />
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    pregnant, due
                  </Typography>{" "}
                  <br />
                  <TextField
                    id="outlined-multiline-static"
                    onChange={this.handleInputChange}
                    label="Answer"
                    multiline
                    rows={3}
                    style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                    variant="outlined"
                    name="pregnant"
                    value={this.state.pregnant}
                  />{" "}
                  <br />
                  <FormControl
                    variant="outlined"
                    style={{ marginBottom: 10, marginTop: 10, width: "100%" }}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Menstruation
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      // value={}
                      onChange={this.handleInputChange}
                      label="Menstruation"
                      name="menstruation"
                      value={this.state.menstruation}
                    >
                      <MenuItem value="Painful">Painful</MenuItem>
                      <MenuItem value="Heavy">Heavy</MenuItem>
                      <MenuItem value="Light">Light</MenuItem>
                      <MenuItem value="Normal">Normal</MenuItem>
                      <MenuItem value="Irregular">Irregular</MenuItem>
                      <MenuItem value="Absent">Absent</MenuItem>
                    </Select>
                  </FormControl>
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    Menopause
                  </Typography>
                  <TextField
                    id="outlined-multiline-static"
                    onChange={this.handleInputChange}
                    label="Answer"
                    multiline
                    rows={3}
                    style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                    variant="outlined"
                    name="menopause"
                    value={this.state.menopause}
                  />
                  <Typography variant="overline" style={{ textAlign: "left" }}>
                    General Health
                  </Typography>
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    General Health Status
                  </Typography>
                  <FormControl
                    variant="outlined"
                    style={{ marginBottom: 10, marginTop: 10, width: "100%" }}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      // value={}
                      onChange={this.handleInputChange}
                      label="Status"
                      name="generalHealthStatus"
                      value={this.state.generalHealthStatus}
                    >
                      <MenuItem value="Good">Good</MenuItem>
                      <MenuItem value="Average">Average</MenuItem>
                      <MenuItem value="Poor">Poor</MenuItem>
                    </Select>
                  </FormControl>
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    General Stress Levels
                  </Typography>
                  <FormControl
                    variant="outlined"
                    style={{ marginBottom: 10, marginTop: 10, width: "100%" }}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Stress
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      // value={}
                      onChange={this.handleInputChange}
                      label="Stress"
                      name="generalStressLevels"
                      value={this.state.generalStressLevels}
                    >
                      <MenuItem value="High">High</MenuItem>
                      <MenuItem value="Moderate">Moderate</MenuItem>
                      <MenuItem value="Low">Low</MenuItem>
                    </Select>
                  </FormControl>
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    Diet
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.regularMeals}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="regularMeals"
                        value={this.state.regularMeals}
                      />
                    }
                    label="Regular meals"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.irregularEating}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="irregularEating"
                        value={this.state.irregularEating}
                      />
                    }
                    label="Irregular Eating"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.caffeine}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="caffeine"
                        value={this.state.caffeine}
                      />
                    }
                    label="Caffeine"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.smoke}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="smoke"
                        value={this.state.smoke}
                      />
                    }
                    label="Smoke-Pkg(s)/day"
                  />
                  {this.state.consentNaturopathic && (
                    <div>
                      <br />
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "left" }}
                      >
                        Please describe any dietary restrictions you may have:
                      </Typography>
                      <TextField
                        id="outlined-multiline-static"
                        onChange={this.handleInputChange}
                        label="Answer"
                        multiline
                        rows={3}
                        style={{
                          marginBottom: 20,
                          marginTop: 10,
                          width: "100%",
                        }}
                        variant="outlined"
                        name="Diet_Restrictions"
                        value={this.state.Diet_Restrictions}
                      />
                      <br />
                      <br />
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "left" }}
                      >
                        Additional comments or things you would like to change
                        about your diet:
                      </Typography>
                      <TextField
                        id="outlined-multiline-static"
                        onChange={this.handleInputChange}
                        label="Answer"
                        multiline
                        rows={3}
                        style={{
                          marginBottom: 20,
                          marginTop: 10,
                          width: "100%",
                        }}
                        variant="outlined"
                        name="Diet_AdditionalComments"
                        value={this.state.Diet_AdditionalComments}
                      />
                      <br />
                      <br />
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "left" }}
                      >
                        Please rate your energy on a scale of 1 to 10 (1- low ,
                        10- very high):
                      </Typography>
                      <TextField
                        id="outlined-multiline-static"
                        onChange={this.handleInputChange}
                        label="Answer"
                        style={{
                          marginBottom: 20,
                          marginTop: 10,
                          width: "100%",
                        }}
                        variant="outlined"
                        name="Diet_RateYourEnergy"
                        value={this.state.Diet_RateYourEnergy}
                      />
                      <br />
                      <br />
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "left" }}
                      >
                        Please rate your level of stress on a scale of 1 to 10
                        (1- low and 10 -very high):
                      </Typography>
                      <TextField
                        id="outlined-multiline-static"
                        onChange={this.handleInputChange}
                        label="Answer"
                        style={{
                          marginBottom: 20,
                          marginTop: 10,
                          width: "100%",
                        }}
                        variant="outlined"
                        name="Diet_RateYourStress"
                        value={this.state.Diet_RateYourStress}
                      />
                      <br />
                      <br />
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "left" }}
                      >
                        What is your biggest source of stress?
                      </Typography>
                      <TextField
                        id="outlined-multiline-static"
                        onChange={this.handleInputChange}
                        label="Answer"
                        multiline
                        rows={3}
                        style={{
                          marginBottom: 20,
                          marginTop: 10,
                          width: "100%",
                        }}
                        variant="outlined"
                        name="Diet_BiggestSourceOfStress"
                        value={this.state.Diet_BiggestSourceOfStress}
                      />
                    </div>
                  )}
                  <br />
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    Exercise
                  </Typography>
                  <FormControl
                    variant="outlined"
                    style={{ marginBottom: 10, marginTop: 10, width: "100%" }}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Exercise
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      // value={}
                      onChange={this.handleInputChange}
                      label="exercise"
                      name="exercise"
                      value={this.state.exercise}
                    >
                      <MenuItem value="Regular">Regular</MenuItem>
                      <MenuItem value="Occasional">Occasional</MenuItem>
                      <MenuItem value="Little">Little</MenuItem>
                      <MenuItem value="None">None</MenuItem>
                    </Select>
                  </FormControl>
                  {this.state.consentNaturopathic && (
                    <div>
                      <br />
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "left" }}
                      >
                        Please indicate your level of physical activity:
                      </Typography>
                      <FormControl
                        variant="outlined"
                        style={{
                          marginBottom: 10,
                          marginTop: 10,
                          width: "100%",
                        }}
                      >
                        <InputLabel id="demo-simple-select-outlined-label">
                          Physical Activity
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          // value={}
                          onChange={this.handleInputChange}
                          label="Exercise_ActivityLevel"
                          name="Exercise_ActivityLevel"
                          value={this.state.Exercise_ActivityLevel}
                        >
                          <MenuItem value="Less than 1 time per week">
                            Less than 1 time per week
                          </MenuItem>
                          <MenuItem value="1-2 times per week">
                            1-2 times per week
                          </MenuItem>
                          <MenuItem value="3-5 times per week">
                            3-5 times per week
                          </MenuItem>
                          <MenuItem value="Greater than 5 times per week">
                            Greater than 5 times per week
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <br />
                      <br />
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "left" }}
                      >
                        Please describe the type of physical activity
                      </Typography>
                      <TextField
                        id="outlined-multiline-static"
                        onChange={this.handleInputChange}
                        label="Answer"
                        style={{
                          marginBottom: 20,
                          marginTop: 10,
                          width: "100%",
                        }}
                        variant="outlined"
                        name="Exercise_TypeofActivity"
                        value={this.state.Exercise_TypeofActivity}
                      />
                      <br />
                      <br />
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "left" }}
                      >
                        Please write any other relevant health or personal
                        information that you feel is missing:
                      </Typography>
                      <TextField
                        id="outlined-multiline-static"
                        onChange={this.handleInputChange}
                        label="Answer"
                        multiline
                        rows={3}
                        style={{
                          marginBottom: 20,
                          marginTop: 10,
                          width: "100%",
                        }}
                        variant="outlined"
                        name="Exercise_OtherRelevantInfo"
                        value={this.state.Exercise_OtherRelevantInfo}
                      />
                      <br />
                      <br />
                    </div>
                  )}
                  {this.state.consentNaturopathic && (
                    <div>
                      <br />
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "left" }}
                      >
                        Please list your current healthcare providers (Name;
                        Profession; Phone Number)
                      </Typography>
                      <TextField
                        id="outlined-multiline-static"
                        onChange={this.handleInputChange}
                        label="Answer"
                        multiline
                        rows={3}
                        style={{
                          marginBottom: 20,
                          marginTop: 10,
                          width: "100%",
                        }}
                        variant="outlined"
                        name="currentHealthCareProviders"
                        value={this.state.currentHealthCareProviders}
                      />
                      <br />
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "left" }}
                      >
                        Please describe the health concerns you would like
                        support with, in order of importance to you:
                      </Typography>
                      <TextField
                        id="outlined-multiline-static"
                        onChange={this.handleInputChange}
                        label="Answer"
                        multiline
                        rows={3}
                        style={{
                          marginBottom: 20,
                          marginTop: 10,
                          width: "100%",
                        }}
                        variant="outlined"
                        name="describeYourHealthConcerns"
                        value={this.state.describeYourHealthConcerns}
                      />
                    </div>
                  )}
                  <br />
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    Previous Health Care
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.previousMassage}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="previousMassage"
                        value={this.state.previousMassage}
                      />
                    }
                    label="Massage Therapy"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.previousChiro}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="previousChiro"
                        value={this.state.previousChiro}
                      />
                    }
                    label="Chiropractic"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.previousPhysio}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="previousPhysio"
                        value={this.state.previousPhysio}
                      />
                    }
                    label="Physiotherapy"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.previousAcu}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="previousAcu"
                        value={this.state.previousAcu}
                      />
                    }
                    label="Acupuncture"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.previousOsteo}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="previousOsteo"
                        value={this.state.previousOsteo}
                      />
                    }
                    label="Osteopathy"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.previousPsycho}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="previousPsycho"
                        value={this.state.previousPsycho}
                      />
                    }
                    label="Psychotherapy"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.previousNaturopathic}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="previousNaturopathic"
                        value={this.state.previousNaturopathic}
                      />
                    }
                    label="Naturopathic"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.previousHomeopathic}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="previousHomeopathic"
                        value={this.state.previousHomeopathic}
                      />
                    }
                    label="Homeopathic"
                  />
                  <br />
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    Date of last full physical
                  </Typography>
                  <TextField
                    id="outlined-multiline-static"
                    onChange={this.handleInputChange}
                    label="Answer"
                    style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                    variant="outlined"
                    name="dateOfLastFullPhysical"
                    value={this.state.dateOfLastFullPhysical}
                  />
                  <br />
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    Do you have any other medical conditions? (e.g. depression,
                    mental illness, anemia, gout, haemophilia, osteoporosis…)
                    what?
                  </Typography>
                  <TextField
                    id="outlined-multiline-static"
                    onChange={this.handleInputChange}
                    label="Answer"
                    style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                    variant="outlined"
                    name="otherMedicalConditions"
                    value={this.state.otherMedicalConditions}
                  />
                  <br />
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    Do you have any internal pins, wires, artificial joints or
                    special equipment? what? where?
                  </Typography>
                  <TextField
                    id="outlined-multiline-static"
                    onChange={this.handleInputChange}
                    label="Answer"
                    style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                    variant="outlined"
                    name="internalPins"
                    value={this.state.internalPins}
                  />
                  <br />
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    Dental surgery/procedure
                  </Typography>
                  <TextField
                    onChange={this.handleInputChange}
                    id="outlined-multiline-static"
                    label="Answer"
                    style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                    variant="outlined"
                    name="dentalSurgery"
                    value={this.state.dentalSurgery}
                  />
                  <br />
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    Of Special Note: (Pins, Wires, Prosthetics, Walker, Cane,
                    Oral Appliances etc.)
                  </Typography>
                  <TextField
                    onChange={this.handleInputChange}
                    id="outlined-multiline-static"
                    label="Answer"
                    style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                    variant="outlined"
                    name="ofSpecialNote"
                    value={this.state.ofSpecialNote}
                  />
                  <br />
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    For pain relief patients only: using these diagrams circle
                    any areas of discomfort
                  </Typography>
                  {/* Canvas */}
                  <SignatureCanvas
                    penColor="black"
                    ref={(ref) => {
                      this.sigCanvas = ref;
                    }}
                    canvasProps={{
                      width: 652,
                      height: 446,
                      className: "sigCanvas",
                    }}
                  />
                  {/* <canvas
                                        ref={canvasA => this.canvasA = canvasA} /> */}
                  <br />
                  <Button onClick={this.clear}>Clear</Button>
                  <br />
                  <br />
                  <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                    Additional information or details
                  </Typography>
                  <TextField
                    onChange={this.handleInputChange}
                    id="outlined-multiline-static"
                    label="Answer"
                    style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                    variant="outlined"
                    name="additionalInfo"
                    value={this.state.additionalInfo}
                  />
                  <br />
                  <br /> <br />
                  <Typography variant="h3" style={{ textAlign: "left" }}>
                    Informed Consent Forms
                  </Typography>
                  <br />
                  <Typography variant="subtitle1" style={{ textAlign: "left" }}>
                    Please sign the consent forms below for the services that
                    you selected. You may also select and sign the following two
                    consent forms if needed.
                  </Typography>
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.consentSensitive}
                        onChange={this.handleCheckBoxChange}
                        name="consentSensitive"
                        color="primary"
                        value={this.state.consentSensitive}
                      />
                    }
                    label="Sensitive Area Consent Form"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.consentTelus}
                        onChange={this.handleCheckBoxChange}
                        color="primary"
                        name="consentTelus"
                        value={this.state.consentTelus}
                      />
                    }
                    label="Direct Billing Consent Form"
                  />
                  <br />
                </Grid>
              </Grid>
              <Typography variant="h5" style={{ textAlign: "left" }}>
                Signatory
              </Typography>
              <br />
              <Typography variant="body1" style={{ textAlign: "left" }}>
                Please select who will be consenting to and signing these forms:
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.IWillBeSigning}
                    onChange={this.handleCheckBoxChange}
                    color="primary"
                    name="IWillBeSigning"
                    value={this.state.IWillBeSigning}
                  />
                }
                label="I will be signing these forms"
              />
              <br />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.substituteSignature}
                    onChange={this.handleCheckBoxChange}
                    color="primary"
                    name="substituteSignature"
                    value={this.state.substituteSignature}
                  />
                }
                label="My substitute decision maker (I am unable to or am under the age of 18)"
              />
              <TextField
                onChange={this.handleInputChange}
                id="outlined-multiline-static"
                label="Decision Maker's Full Name (if applicable)"
                style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                variant="outlined"
                name="substituteSignatureName"
                value={this.state.substituteSignatureName}
              />
              {/* Acupuncture Consent Form */}
              {this.state.consentAcupuncture && (
                <AcupunctureConsent
                  checked={this.state.consentAcupuncture}
                  onChange={this.handleConsentChange}
                  readOnly={this.state.isHistoricalRecord}
                  version={this.getConsentVersionMetadata(
                    CONSENT_TYPES.ACUPUNCTURE,
                  )}
                  answers={{
                    consentBleedEasily: this.state.consentBleedEasily,
                    consentPregnant: this.state.consentPregnant,
                    consentHIV: this.state.consentHIV,
                    consentPacemaker: this.state.consentPacemaker,
                    consentMetal: this.state.consentMetal,
                  }}
                  signatureRef={(ref) => {
                    this.consentAcupunctureSig = ref;
                  }}
                  onClearSignature={this.clearAcu}
                />
              )}
              {/* Osteopathy Consent Form */}
              {this.state.consentOsteopathy &&
                (() => {
                  const osteoSnapshot =
                    this.state.consentSnapshots?.[CONSENT_TYPES.OSTEOPATHY];
                  const osteoAnswers = osteoSnapshot
                    ? osteoSnapshot.answers || {}
                    : {
                        osteo_temporarySoreness:
                          this.state.osteo_temporarySoreness,
                        osteo_pressure: this.state.osteo_pressure,
                        osteo_strenuousActivity:
                          this.state.osteo_strenuousActivity,
                        osteo_communicateDiscomfort:
                          this.state.osteo_communicateDiscomfort,
                        osteo_noSpecificOutcome:
                          this.state.osteo_noSpecificOutcome,
                      };

                  return (
                    <OsteopathyConsent
                      checked={this.state.consentOsteopathy}
                      onChange={this.handleConsentChange}
                      readOnly={this.state.isHistoricalRecord}
                      version={this.getConsentVersionMetadata(
                        CONSENT_TYPES.OSTEOPATHY,
                      )}
                      answers={osteoAnswers}
                      signatureRef={(ref) => {
                        this.consentOsteoSig = ref;
                      }}
                      onClearSignature={this.clearOsteo}
                    />
                  );
                })()}
              {/* Massage Consent Form */}
              {this.state.consentMassage &&
                (() => {
                  const massageSnapshot =
                    this.state.consentSnapshots?.[CONSENT_TYPES.MASSAGE];
                  const massageAnswers = massageSnapshot
                    ? massageSnapshot.answers || {}
                    : {
                        massage_postTreatmentSoreness:
                          this.state.massage_postTreatmentSoreness,
                        massage_deepTissue: this.state.massage_deepTissue,
                        massage_strenuousActivity:
                          this.state.massage_strenuousActivity,
                        massage_communicateDiscomfort:
                          this.state.massage_communicateDiscomfort,
                        massage_noSpecificOutcome:
                          this.state.massage_noSpecificOutcome,
                      };

                  return (
                    <MassageConsent
                      checked={this.state.consentMassage}
                      onChange={this.handleConsentChange}
                      readOnly={this.state.isHistoricalRecord}
                      version={this.getConsentVersionMetadata(
                        CONSENT_TYPES.MASSAGE,
                      )}
                      answers={massageAnswers}
                      signatureRef={(ref) => {
                        this.consentMassageSig = ref;
                      }}
                      onClearSignature={this.clearMassage}
                    />
                  );
                })()}
              {/* Reiki Consent Form */}
              {this.state.consentReiki && (
                <ReikiConsent
                  checked={this.state.consentReiki}
                  onChange={this.handleConsentChange}
                  readOnly={this.state.isHistoricalRecord}
                  version={this.getConsentVersionMetadata(CONSENT_TYPES.REIKI)}
                  answers={{
                    reikiConsentAndWaiver: this.state.reikiConsentAndWaiver,
                    reikiTestimonialDisclaimer:
                      this.state.reikiTestimonialDisclaimer,
                    reikiAssumptionOfRisk: this.state.reikiAssumptionOfRisk,
                    reikiGoverningLaw: this.state.reikiGoverningLaw,
                    reikiExclusiveJurisdiction:
                      this.state.reikiExclusiveJurisdiction,
                  }}
                  signatureRef={(ref) => {
                    this.consentReikiSig = ref;
                  }}
                  onClearSignature={this.clearReiki}
                />
              )}
              {/* Consent for Naturopathy */}
              {this.state.consentNaturopathic && (
                <NaturopathicConsent
                  checked={this.state.consentNaturopathic}
                  onChange={this.handleConsentChange}
                  readOnly={this.state.isHistoricalRecord}
                  version={this.getConsentVersionMetadata(
                    CONSENT_TYPES.NATUROPATHIC,
                  )}
                  signatureRef={(ref) => {
                    this.consentNaturopathicSig = ref;
                  }}
                  onClearSignature={this.clearNaturopathic}
                />
              )}
              {/* General Consent */}
              <GeneralConsent
                onChange={this.handleConsentChange}
                readOnly={this.state.isHistoricalRecord}
                version={this.getConsentVersionMetadata(CONSENT_TYPES.GENERAL)}
                answers={{
                  Accuracy_IAgree: this.state.Accuracy_IAgree,
                  CancellationPolicy_IAgree:
                    this.state.CancellationPolicy_IAgree,
                  EmailCommunication_IAgree:
                    this.state.EmailCommunication_IAgree,
                  PrivacyPolicy_IAgree: this.state.PrivacyPolicy_IAgree,
                }}
                signatureRef={(ref) => {
                  this.consentGeneralSig = ref;
                }}
                onClearSignature={this.clearGeneral}
              />
              {/* Sensitive Areas Consent Form */}
              {this.state.consentSensitive && (
                <SensitiveAreasConsent
                  checked={this.state.consentSensitive}
                  onChange={this.handleConsentChange}
                  readOnly={this.state.isHistoricalRecord}
                  version={this.getConsentVersionMetadata(
                    CONSENT_TYPES.SENSITIVE_AREAS,
                  )}
                  signatureRef={(ref) => {
                    this.consentSensitiveSig = ref;
                  }}
                  onClearSignature={this.clearSensitive}
                />
              )}
              {/* Electronic Auth Consent Form */}
              {this.state.consentTelus && (
                <TelusConsent
                  checked={this.state.consentTelus}
                  onChange={this.handleConsentChange}
                  readOnly={this.state.isHistoricalRecord}
                  version={this.getConsentVersionMetadata(CONSENT_TYPES.TELUS)}
                  answers={{
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    dob: this.state.dob,
                    gender: this.state.gender,
                    primaryCoverage: this.state.primaryCoverage,
                    planMember: this.state.planMember,
                    policyNumber: this.state.policyNumber,
                    coverageCert: this.state.coverageCert,
                    canadaLife: this.state.canadaLife,
                    consentAcceptTerms: this.state.consentAcceptTerms,
                  }}
                  signatureRef={(ref) => {
                    this.consentTelusSig = ref;
                  }}
                  onClearSignature={this.clearTelus}
                />
              )}
              <Grid container style={{ marginBottom: 20 }} spacing={2}>
                <Grid item xs={12} sm={4}></Grid>
                <Grid item xs={12} sm={4}></Grid>
                <Grid item xs={12} sm={4}></Grid>
              </Grid>
              <Typography variant="subtitle1">
                Once you click submit, you will be redirected back to the home
                page. Please select your name and sign in from there.
              </Typography>{" "}
              <br />
              <br />
              {this.state.displayError && (
                <p style={{ color: "red" }}>
                  Please make sure you filled in the form correctly.
                </p>
              )}
              {this.state.email &&
              this.state.firstName &&
              this.state.lastName &&
              this.state.cellPhone ? (
                <Button
                  style={{
                    marginTop: 30,
                    width: 120,
                    borderRadius: 20,
                    color: "002BB8",
                  }}
                  type="submit"
                  variant="contained"
                  disableElevation
                  color="primary"
                  onClick={this.handleSubmit}
                >
                  Submit!
                </Button>
              ) : (
                <Button
                  disabled
                  style={{
                    marginTop: 30,
                    width: 120,
                    borderRadius: 20,
                    color: "002BB8",
                  }}
                  type="submit"
                  variant="contained"
                  disableElevation
                  color="primary"
                  onClick={this.handleSubmit}
                >
                  Submit!
                </Button>
              )}
              {/* <Button style={{ marginTop: 30, width: 120, borderRadius: 20, color: "002BB8" }} type="submit" variant="contained" disableElevation color="primary" onClick={this.handleSubmit}
                            >
                                Submit!
                            </Button> */}
              <br />
              <br />
              <hr style={{ opacity: "20%" }} />
            </Grid>
          </Grid>
        </ThemeProvider>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    patients: state.patients,
    visits: state.visits,
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    fetchVisits,
    fetchPatients,
  }),
)(withRouter(IntakeForm));
